export type CreateTeamErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class CreateTeamError extends Error {
    code: CreateTeamErrorCode;

    constructor(code: CreateTeamErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
